const PersonLined = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    aria-labelledby="title"
    aria-describedby="desc"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Avatar</title>
    <desc>A line styled icon from Orion Icon Library.</desc>
    <path
      data-name="layer2"
      d="M24 40.8V44c0 2-1 5.2-11 7A13.4 13.4 0 0 0 2 62h60a15.5 15.5 0 0 0-12-11c-10-1.9-10-5-10-7v-3.2"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <path
      data-name="layer1"
      d="M46 25.6c0 10-6.3 18.4-14 18.4s-14-8-14-18v-9.6C18 6 25.4 2 32 2s14 3.6 14 14z"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
  </svg>
);

export default PersonLined;
